import Services, {type ServicesConfig} from './src/services/Services';

class InitSharedRepo {
  static init(config?: ServicesConfig): void {
    Services.init(config);
  }

  static initAfterAuth(config: {token: string}): void {
    Services.initAfterAuth(config);
  }
}

export default InitSharedRepo;
